import { render, staticRenderFns } from "./SASBTableMicro.vue?vue&type=template&id=38b1e20a&scoped=true"
import script from "./SASBTableMicro.vue?vue&type=script&lang=js"
export * from "./SASBTableMicro.vue?vue&type=script&lang=js"
import style0 from "./SASBTableMicro.vue?vue&type=style&index=0&id=38b1e20a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b1e20a",
  null
  
)

export default component.exports